import React from "react";
import { ArticleIcon, VideoIcon, ShortsIcon, NewspaperIcon } from "../components/AdminIcons";
import { formatAdminArticleDate } from "../utils/helpers";

const Dashboard = ({ stats, articles, allUsers }) => {
  const StatCard = ({ title, value, icon }) => (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-md flex items-center">
      <div className="p-3 bg-yellow-100 rounded-full mr-4">{icon}</div>
      <div>
        <p className="text-sm text-gray-500 font-medium">{title}</p>
        <p className="text-2xl sm:text-3xl font-bold text-gray-800">{value}</p>
      </div>
    </div>
  );

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        <StatCard title="Total Articles" value={stats.articles} icon={<ArticleIcon />} />
        <StatCard title="Total Videos" value={stats.videos} icon={<VideoIcon />} />
        <StatCard title="Total Shorts" value={stats.shorts} icon={<ShortsIcon />} />
        <StatCard title="Total E-Papers" value={stats.epapers} icon={<NewspaperIcon />} />
      </div>
      <div className="mt-8 bg-white p-4 sm:p-6 rounded-lg shadow-md">
        <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4">Recent Articles</h2>
        {articles && articles.length > 0 ? (
          <div className="space-y-4">
            {articles.map((article) => {
              const authorName = allUsers.find((u) => u.id == article.userId)?.username || `ID: ${article.userId}`;
              return (
                <div key={article.id} className="border-b pb-2 last:border-b-0">
                  <h3 className="font-semibold text-gray-800 line-clamp-2 break-words" style={{ overflowWrap: "anywhere" }}>{article.title}</h3>
                  <p className="text-sm text-gray-500">By {authorName} on {formatAdminArticleDate(article)}</p>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-gray-600">No recent articles found.</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
